import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { successStories } from "./successStoriesData";
// import CaseStudyModal from "./caseStudies/CaseStudyModal";
import { motion } from "motion/react";
import { ArrowRight } from "lucide-react";
import { Helmet } from "react-helmet";
const SuccessStories = () => {

  return (
    <>
      <Helmet>
        <title>Success Stories & Case Studies India | AI & Salesforce</title>

        <meta
          name="description"
          content="Explore AI & Salesforce success stories by Comsense. Real case studies showcasing data-driven growth, automation & ROI impact."
        />

        <meta
          name="keywords"
          content="Salesforce case studies India, AI success stories India, marketing automation case studies, data analytics success stories"
        />

        <meta name="robots" content="index, follow" />
        <meta name="author" content="Comsense Technologies" />

        {/* Open Graph */}
        <meta
          property="og:title"
          content="Success Stories & Case Studies India | AI & Salesforce by Comsense"
        />
        <meta
          property="og:description"
          content="Real-world AI & Salesforce case studies delivering measurable growth and ROI."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://comsensetechnologies.com/success-stories"
        />
      </Helmet>
      <style>{`
        .success-stories-page { font-family: 'Outfit', sans-serif; 
        font-family: 'Outfit', sans-serif; background-color: #f8fafc;
        }
          .success-hero {
          padding: 100px 0 100px;
          background: #e2f1fe;
          color: #fff;
          text-align: center;
          position: relative;
          overflow: hidden;
        }

        .hero-title-container {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          text-align: left;
          max-width: 600px;
        }

        .success-hero h1 {
          font-weight: 800;
          margin-bottom: 10px;
          font-size: 42px;
          text-align: left;
          color: #0f172a;
          letter-spacing: -.5px;
        }

        .success-hero p {
          font-size: 16px;
          color: #475569;
          text-align: left;
          max-width: 900px;
          margin-bottom: 0px;
        }

        .hero-monitor-icon {
          position: absolute;
          top: 50%;
          right: 10%;
          transform: translateY(-50%);
          opacity: 0.2;
          pointer-events: none;
        }

        .success-story-listing { padding: 80px 0; }
        .story-card { 
         height: 100%;
  display: flex;
  flex-direction: column; transition: all 0.4s ease;
       background: #fff;
          border-radius: 0;
          border: none;
          overflow: hidden;
          transition: all 0.4s ease;
          height: 100%;
          display: flex;
          flex-direction: column;   }
        .story-card:hover { transform: translateY(-6px); border-color: #e00; }
        .story-card img { width: 100%; height: 220px; object-fit: cover; object-position: top; }
        .story-card-body {     padding: 10px;
          flex-grow: 1;
          display: flex;
          flex-direction: column; }
        .story-title { 
             font-size: 18px;
          font-weight: 700;
          color: #0f172a;
          margin-bottom: 15px;
          line-height: 1.4;
        }
      .story-actions
        {
       margin-top: auto;
          padding-top: 15px;
          // margin-left:10px; 
      }
        .story-excerpt { color: #d1d5db; margin-bottom: 14px; }

        // .story-actions a, .story-actions button { 
        // margin-right: 8px; margin-bottom: 6px; text-decoration: none; color: #fff; background: #ee0000; border: 0; border-radius: 8px; padding: 8px 14px; font-weight: 600; font-size:14px; cursor: pointer; 
        // }

        .story-actions a, .story-actions button { 
        margin-right: 8px; 
        margin-bottom: 0px;
         text-decoration: none; color: #ee0000; background: transparent; border: 0; border-radius: 8px; padding: 8px 14px 0px 14px; font-weight: 600; font-size:14px; cursor: pointer; padding-left:0; 
    
         }

.story-actions button { 
display: flex;
  align-items: center;        
         }

        .story-actions a.details { color: #e00;
  background: #fff;
  border: 1px solid #e00; 
  }
      `}</style>
      <div className="success-stories-page">
        <section className="success-hero">
          <Container>
            <motion.div
              className="hero-title-container"
              initial={{ opacity: 0, x: -30 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
            >
              <h1>Success Stories</h1>
              <p>Touchpoints Of Comsense Engagement Success</p>
            </motion.div>
            <div className="hero-monitor-icon">
              <svg
                width="200"
                height="200"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect>
                <line x1="8" y1="21" x2="16" y2="21"></line>
                <line x1="12" y1="17" x2="12" y2="21"></line>
              </svg>
            </div>
          </Container>
        </section>

        <section className="success-story-listing">
          <Container>
            <Row className="g-4">
              {successStories.map((story) => (
                <Col key={story.id} lg={4} md={6}>
                  <div className="story-card">
                    <img src={story.image} alt={story.title} />
                    <div className="story-card-body">
                      <Link
                        to={`/success-stories/${story.slug}`}
                        className="story-title"
                        style={{ textDecoration: "none" }}
                      >
                        {story.title}
                      </Link>
                      <p className="story-excerpt">{story.excerpt}</p>
                      <div className="story-actions">
                        {/* <Link
                          className="details"
                          to={`/success-stories/${story.slug}`}
                        >
                          View Case Study
                        </Link> */}
                        {/* <button onClick={() => setSelectedStory(story)}>
                          Download PDF <ArrowRight className="ms-2" size={14} />
                        </button> */}
                            <a
                          href={story.pdfFile}
                          target="_blank"
                          rel="noopener noreferrer"
                          download
                        >
                          Download PDF <ArrowRight className="ms-2" size={14} />
                        </a>
                      </div>
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          </Container>
        </section>

        {/* <CaseStudyModal
          show={Boolean(selectedStory)}
          onHide={() => setSelectedStory(null)}
          caseStudyTitle={selectedStory?.title}
          caseStudyPdfFile={selectedStory?.pdfFile}
        /> */}
      </div>
    </>
  );
};

export default SuccessStories;
